const Header = () => {
  return (
    <header className="bg-blue-100 py-4 px-4 border-b mb-4">
      <div className="container mx-auto px-4">
        <h1 className="text-center text-4xl font-bold font-body">Bazaar</h1>
      </div>
    </header>
  );
};

export default Header;
